document.addEventListener("DOMContentLoaded", function() {
  var $textSlider = $('.featured-text-slider');
  var $logoSlider = $('.featured-logo-slider');

  $textSlider.slick({
    infinite: true, 
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    asNavFor: '.featured-logo-slider',
    adaptiveHeight: true,
    fade: true,
    autoplay: true,       
    autoplaySpeed: 5000 
  });

  $logoSlider.slick({
    infinite: true, 
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.featured-text-slider',
  arrows: false,
  focusOnSelect: true,
  centerMode: true,
  autoplay: true,       
    autoplaySpeed: 5000,
  centerPadding: '0px',
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 3, centerMode: true, centerPadding: '0px' } },
    { breakpoint: 768, settings: { slidesToShow: 3, centerMode: true, centerPadding: '0px' } },
    { breakpoint: 480, settings: { slidesToShow: 1, centerMode: true, centerPadding: '40px' } }
  ]
});

  // Custom arrows
  $('.featured-prev').on('click', function() {
    $textSlider.slick('slickPrev');
  });
  $('.featured-next').on('click', function() {
    $textSlider.slick('slickNext');
  });
});
